import React, { useState, useRef } from "react";
import "./RealResults.scss";
import { Row, Col, Button, Carousel, Layout } from "antd";
import { ArrowLeftOutlined, ArrowRightOutlined } from "@ant-design/icons";
import Slider from "react-slick"
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import useSlickAccessibility from "../../../useSlickAccessibility";
const { Content } = Layout;

const carouselData = [
    {
        'img': 'https://d48f7equ64qjl.cloudfront.net/static_files/homepage_assets/results-01-herocraft.jpg',
        'mobile_img': 'https://d48f7equ64qjl.cloudfront.net/static_files/homepage_assets/results-01-herocraft-SM.jpg',
        'title': 'Hero Craft accelerates Amazon launch with ALL3D’s high-quality digital assets ',
        'desc': "Hero Craft, a premium knife sharpening kit brand, faced delays and sunk costs after waiting six weeks for low-quality product images from a traditional provider. Using just two photos, ALL3D’s AI-powered platform delivered photorealistic product images, 3D models, and A+ content in under a week—far exceeding the original results. This speed and quality helped Hero Craft launch on Amazon with high-impact visuals.",
        'key_wins': [
            {
                'icon': '/smb/lightning-light.png',
                'desc': 'Delivered 3D models, images, and A+ content in under a week'
            },
            {
                'icon': '/smb/up.svg',
                'desc': 'Boosted conversion potential and long-term success'
            }
        ],
        'logo': '/new_homepage/herocraft.png',
        'logo_width': '47px',
        'link_text': 'View Herocraft on Amazon',

        'link': 'https://www.amazon.com/stores/HeroCraft/page/1F345014-DAD9-475D-8ECC-2E2DD8CC1AC7?lp_asin=B0DJMTQ2W6&ref_=ast_bln'
    },
    {
        'img': 'https://d48f7equ64qjl.cloudfront.net/static_files/homepage_assets/results-02-skyline.jpg',
        'mobile_img': 'https://d48f7equ64qjl.cloudfront.net/static_files/homepage_assets/results-02-skyline-SM.jpg',
        'title': 'Skyline revolutionizes home décor with ALL3D’s innovative 3D technology',
        'desc': "Chicago-based Skyline partnered with ALL3D to develop a custom 3D rendering tool, enabling its team to create detailed product visuals in-house. Integrated into Skyline’s website and trade portal, this technology enhances supply chain efficiency, eliminates costly photo shoots, and supports the brand’s three-week delivery promise for eco-conscious, customizable décor.",
        'key_wins': [
            {
                'icon': '/smb/ribbon.svg',
                'desc': 'Industry-leader in delivery for customized products shipped in just three weeks'
            },
            {
                'icon': '/smb/point.svg',
                'desc': 'Industry-leader in delivery for customized products shipped in just three weeks'
            }
        ],
        'logo': '/new_homepage/skyline.jpg',
        'logo_width': '127px',
        'link_text': 'View Skyline website',
        'link': 'https://skylinefurnituremfg.com/'
    },
    {
        'img': 'https://d48f7equ64qjl.cloudfront.net/static_files/homepage_assets/results-03-sqai.jpg',
        'mobile_img': 'https://d48f7equ64qjl.cloudfront.net/static_files/homepage_assets/results-03-sqai-SM.jpg',
        'title': 'SQAI launches faster with cost-effective 3D modeling from ALL3D',
        'desc': "Fitness-tech startup SQAI, co-founded by former Amazon executive Alec Oliver, used ALL3D’s platform to accelerate its EMS suit launch. ALL3D created a high-quality, technically accurate 3D model quickly, eliminating the need for traditional photoshoots. This streamlined process helped SQAI schocase its innovative product and meet its launch deadline.",
        'key_wins': [
            {
                'icon': '/smb/lightning-light.png',
                'desc': 'Delivered a high-quality 3D model in record time'
            },
            {
                'icon': '/smb/pig-light.png',
                'desc': 'Avoided the expense of traditional product photography'
            }
        ],
        'logo': '/new_homepage/sqai.svg',
        'logo_width': '80px',
        'link_text': 'View SQAI website',
        'link': 'https://sqai.co/'
    },
    {
        'img': 'https://d48f7equ64qjl.cloudfront.net/static_files/homepage_assets/results-04-hooker.jpg',
        'mobile_img': '/landingPage/hooker_1.png',
        'title': '',
        'desc': "At Hooker, our products are crafted from meticulously sourced materials and brought to life with exceptional care and precision. Each piece reflects our unwavering commitment to quality and design excellence. As a result, the imagery we use to represent our products must meet the same exacting standards as the products themselves. All3D's AI platform has proven to be an outstanding solution for showcasing our products at the level they deserve. The platform captures intricate product details—textures, finishes, construction elements, and scale—with remarkable accuracy, surpassing the capabilities of all other AI image tools we have evaluated. The resulting imagery is consistently photorealistic, allowing our products to be presented in refined, authentic scenes that align with our brand's premium positioning. Equally impressive is the ease and precision with which images can be edited. Using simple, intuitive AI prompts, we are able to make accurate adjustments to scale, decor, lighting, and environments without compromising realism or efficiency. The All3D AI platform is easy to use and delivers exceptional visual results. All3D has become an invaluable partner in helping us visually communicate the craftsmanship, quality, and attention to detail that define Hooker Furnishings.",
        'key_wins': [
        
        ],
        'logo': '/landingPage/hooker_testimonial_logo.jpg',
        'logo_width': '120px',
        'link_text': 'View Hooker Furnishings website',
        'link': 'https://www.hookerfurniture.com/',
        'customLayout': true,
        'images': [
            '/landingPage/hooker_1.png',
            '/landingPage/hooker_2.png',
            '/landingPage/hooker_3.png',
        ]
            
    }
]

const RealResults = () => {

    return (
        <>
            <WebVersion />
            <MobileVersion />
        </>
    );
}

const WebVersion = () => {

    let carousel = React.createRef();
    const carouselContainerRef = useRef(null);

    useSlickAccessibility(carouselContainerRef);


    const next = () => {
        if (carousel) {
            carousel.next();
        }
    };

    const prev = () => {
        if (carousel) {
            carousel.prev();
        }
    };


    return (
        <Content className="d-none d-lg-block">
            <Row className="container-fluid justify-in-center sellers-win-bg">
                <Col span={24} className="justify-in-center text-center mb-56">
                    <h1 className="manrope f-38 lh-46 w-600 white">Real Results</h1>
                </Col>

                <Col span={2} className="direction-flex justify-in-start">
                    <Button onClick={prev}
                        icon={<ArrowLeftOutlined className="manrope f-20 lh-0" />}
                        className="carousel-btn-ar"
                    />
                </Col>

                <Col span={18}>
                    <div className="seller-win" ref={carouselContainerRef}>
                        <Carousel
                            dots={true}
                            autoplay={false}
                            ref={(node) => carousel = node}
                            style={{ width: "100%" }}>
                            {carouselData.map((data, index) => (
                                <Row className="win-slide-bg-real">
                                    <Col span={12}>
                                        {data.customLayout ? (
                                            <div className="hooker-image-layout">
                                                <div className="hooker-logo-section">
                                                    <img src={data.logo} width={data.logo_width} className="hooker-logo" alt="Hooker Furnishings" />
                                                </div>
                                                <div className="hooker-images-grid">
                                                    <div className="hooker-img-large">
                                                        <img src={data.images[0]} alt="Hooker product 1" />
                                                    </div>
                                                    <div className="hooker-img-small-container">
                                                        <div className="hooker-img-small">
                                                            <img src={data.images[1]} alt="Hooker product 2" />
                                                        </div>
                                                        <div className="hooker-img-small">
                                                            <img src={data.images[2]} alt="Hooker product 3" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ) : (
                                            <img src={data.img} alt={data.title || "Case study"} className="seller-img" />
                                        )}
                                    </Col>
                                    <Col span={12} className="carousel-text-col">
                                        {data.customLayout ? (
                                            <div className="hooker-text-content">
                                                <p className="manrope f-14 w-500 black-085 lh-22 text-left">{data.desc}</p>
                                                <div className="justify-in-end direction-flex mt-24">
                                                    <a href={data.link} target="_blank" rel="noopener noreferrer" className="manrope f-14 w-500 blue cursor pointer text-left">{data.link_text} <ArrowRightOutlined className="ml-8" /></a>
                                                </div>
                                            </div>
                                        ) : (
                                            <>
                                                <div>
                                                    <div>
                                                        <h3 className="manrope f-20 black-085 w-700 lh-28 text-left">{data.title}</h3>
                                                        <p className="manrope f-14 w-500 black-085 lh-22 text-left mb-24">{data.desc}</p>
                                                    </div>
                                                    <div className="j-sb-a-start gap-16-seller">
                                                        {data.key_wins.map((win, index) => (
                                                            <Col span={data.key_wins.length == 1 ? 24 : 11} className="j-start-a-start direction-flex">
                                                                <img src={win.icon} alt="" />
                                                                <p className="manrope f-14 lh-22 black-085 w-500 text-left ml-8 mb-0">{win.desc}</p>
                                                            </Col>
                                                        ))}
                                                    </div>
                                                </div>
                                                <div className="justify-space-between">
                                                    <Col span={12}>
                                                        <img src={data.logo} width={data.logo_width} alt="" className="logo-icon" />
                                                    </Col>
                                                    <Col span={12} className="justify-in-end direction-flex">
                                                        <a href={data.link} target="_blank" rel="noopener noreferrer" className="manrope f-14 w-500 blue  cursor pointer justify-in-end text-left">{data.link_text} <ArrowRightOutlined className="ml-8" /></a>
                                                    </Col>
                                                </div>
                                            </>
                                        )}
                                    </Col>

                                </Row>
                            ))}
                        </Carousel>
                    </div>
                </Col>
                <Col span={2} className="direction-flex justify-in-end">
                    <Button onClick={next}
                        icon={<ArrowRightOutlined className="manrope f-20 lh-0" />}
                        className="carousel-btn-ar"
                    />
                </Col>
            </Row>
        </Content>
    );
}

const MobileVersion = () => {
    const [isExpanded, setIsExpanded] = useState(false);
    const sliderContainerRef = useRef(null);

    useSlickAccessibility(sliderContainerRef);

    const settings = {
        autoplay: false,
        dots: true,
        infinite: true,
        speed: 600,
        slidesToShow: 1.07,
        slidesToScroll: 1,
        vertical: false,
        customPaging: i => (
            <div className="custom-dot">
                {/* &ndash;  This is the dash */}
            </div>
        ),
    };

    return (
        <Content className="d-lg-none">
            <Row className="container-fluid justify-in-center sellers-win-bg">
                <Col span={24} className="justify-in-center text-center mb-32 pdlr-16">
                    <h1 className="manrope f-30 lh-46 w-600 white">Real Results</h1>
                </Col>

                <Col span={24} className="pdl-16">
                    <div ref={sliderContainerRef}>
                    <Slider {...settings} className="wins-card">
                        {carouselData.map((data, index) => (
                            <Row className={`win-slide-bg-real ${index == 0 ? `first` : ``}`}>
                                <div className={`box ${isExpanded ? 'expanded' : ''}`}>
                                    <div className="img-setting-col">
                                        <img src={data.mobile_img} alt={data.title || "Case study"} className="seller-img mb-24" />
                                    </div>
                                    <div className="pdlr-16">
                                        <div>
                                            <h3 className="manrope f-20 black-085 w-700 lh-28 text-left mb-8">{data.title}</h3>
                                            {isExpanded ?
                                                <p className="manrope f-16 w-500 black-085 lh-24 text-left">
                                                    {data.desc}
                                                </p> : ''}
                                            <button type="button" onClick={() => setIsExpanded(!isExpanded)}
                                                className="manrope f-16 w-500 blue lh-24 text-left mb-24">
                                                {isExpanded ? 'Read Less' : 'Read More'}
                                            </button>

                                        </div>
                                        <div className="j-sb-a-start direction-flex mb-32">
                                            {data.key_wins.map((win, index) => (
                                                <Col span={data.key_wins.length == 1 ? 24 : 12}>
                                                    <img src={win.icon} alt="" className="mb-8" />
                                                    <p className="manrope f-14 lh-22 black-085 w-500 text-left ml-8">{win.desc}</p>
                                                </Col>
                                            ))}
                                        </div>
                                    </div>

                                    <div className="pdlr-16">
                                        <img src={data.logo} width={data.logo_width} alt="" className="mb-8 logo-icon" />
                                        <a href={data.link} className="manrope f-14 w-500 blue cursor pointer justify-space-between">
                                            {data.link_text} <ArrowRightOutlined className="ml-8" />
                                        </a>

                                    </div>
                                </div>
                            </Row>
                        ))}
                    </Slider>
                    </div>
                </Col>

            </Row>
        </Content>
    );
}


export default RealResults;
